import request from '@/http/request'

export const nfcDailyReportPage = () => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc-email/api/report/daily`)
}

export const nfcDailyReportDownload = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc-email/api/report/daily/download`, {
    params,
    responseType: 'blob',
    uploadOrDownload: true
  })
}
